import React, { Component } from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SendToL2ApprovalModalSF from './SendToL2ApprovalModalSF'
import ApproveReworkModalSF from './ApproveReworkModalSF.js'
import L1ApproveReworkModalSF from './L1ApproveReworkModalSF'
import SendToFinanceModalSF from './SendToFinanceModalSF'
import AddRemarkModalSF from './AddRemarkModalSF'
import ErrorModalUI from './ErrorModalUI'
const NON_LINKABLE_CP_CODES = [
  'dsra_10_percent',
  'processing_fee',
  'promoter_contribution',
  'company_kyc',
  'director_kyc',
  'current_shareholding_pattern'
]

class DisbursementChecklistViewUI extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSendModal: false,
      showL2ApproveReworkModal: false,
      showL1ApproveReworkModal: false,
      showSendToFinanceModal: false,
      showApprovalInfo: false,
      showAddRemarkModal: false,
      selectedItem: null,
      showReworkWarningModal: false,
      reworkWarningMessage: null,
      reworkWarningType: 'l2' // 'l2' or 'l1'
    }
  }

  onSendL2ApprovalClick = () => {
    this.setState({ showSendModal: true })
  }

  onL2ApproveReworkClick = () => {
    // Check if already in rework status
    if (this.checkIfAlreadyInRework('l2')) {
      return
    }
    this.setState({ showL2ApproveReworkModal: true })
  }

  onL1ApproveReworkClick = () => {
    // Check if already in rework status
    if (this.checkIfAlreadyInRework('l1')) {
      return
    }
    this.setState({ showL1ApproveReworkModal: true })
  }

  checkIfAlreadyInRework = (level) => {
    const { checklist } = this.props

    if (!checklist) return false

    // Check if status is already in rework
    if (level === 'l2' && checklist.status === 'l2_rework') {
      this.setState({
        showReworkWarningModal: true,
        reworkWarningMessage: 'This checklist has already been sent to L2 rework.',
        reworkWarningType: 'l2'
      })
      return true
    }

    if (level === 'l1' && checklist.status === 'l1_rework') {
      this.setState({
        showReworkWarningModal: true,
        reworkWarningMessage: 'This checklist has already been sent to L1 rework.',
        reworkWarningType: 'l1'
      })
      return true
    }

    // Additional check: if any level is in rework, warn the user
    if (checklist.status === 'l2_rework' || checklist.status === 'l1_rework') {
      const currentLevel = checklist.status === 'l2_rework' ? 'L2' : 'L1'
      this.setState({
        showReworkWarningModal: true,
        reworkWarningMessage: `This checklist is currently in ${currentLevel} rework status. Please complete the rework process before sending it for another review.`,
        reworkWarningType: level
      })
      return true
    }

    return false
  }

  onSendToFinanceClick = () => {
    this.setState({ showSendToFinanceModal: true })
  }

  onAddRemarkClick = (item) => {
    this.setState({
      showAddRemarkModal: true,
      selectedItem: item
    })
  }

  onCloseSendModal = () => {
    this.setState({ showSendModal: false })
  }

  onCloseL2ApproveReworkModal = () => {
    this.setState({ showL2ApproveReworkModal: false })
  }

  onCloseL1ApproveReworkModal = () => {
    this.setState({ showL1ApproveReworkModal: false })
  }

  onCloseSendToFinanceModal = () => {
    this.setState({ showSendToFinanceModal: false })
  }

  onCloseAddRemarkModal = () => {
    this.setState({
      showAddRemarkModal: false,
      selectedItem: null
    })
  }

  onCloseReworkWarningModal = () => {
    this.setState({
      showReworkWarningModal: false,
      reworkWarningMessage: null,
      reworkWarningType: 'l2'
    })
  }

  onModalSuccess = () => {
    this.setState({
      showSendModal: false,
      showL2ApproveReworkModal: false,
      showL1ApproveReworkModal: false,
      showSendToFinanceModal: false,
      showAddRemarkModal: false,
      selectedItem: null
    })
    this.props.onRefreshClick()
  }

  toggleApprovalInfo = () => {
    this.setState(prevState => ({
      showApprovalInfo: !prevState.showApprovalInfo
    }))
  }

  formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A'
    const date = new Date(timestamp)
    const options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }
    return date.toLocaleString('en-US', options)
  }

  renderSentToFinanceInfo = () => {
    const { checklist } = this.props

    if (!checklist || checklist.status !== 'sent_to_finance') return null

    const timestamps = checklist.timestamps && checklist.timestamps[0]
    if (!timestamps || !timestamps.sentToFinanceDate) return null

    // Get the performer's name from approval history
    let performerName = timestamps.lastUpdatedBy || 'N/A'

    // Check approval history for the sent_to_finance event to get the performer's name
    if (checklist.approvalHistory && Array.isArray(checklist.approvalHistory)) {
      const sentToFinanceEvent = checklist.approvalHistory.find(
        event => event.eventType === 'sent_to_finance'
      )
      if (sentToFinanceEvent && sentToFinanceEvent.performedByName) {
        performerName = sentToFinanceEvent.performedByName
      }
    }

    return (
      <div className='g_m_top_100' style={sentToFinanceContainerStyle}>
        <div style={sentToFinanceContentStyle}>
          <span style={sentToFinanceIconStyle}>✓</span>
          <strong style={sentToFinanceHeaderTextStyle}>Sent to Finance Team</strong>
          <span style={sentToFinanceSeparatorStyle}>•</span>
          <span style={sentToFinanceTextStyle}>
            Sent By: <strong>{performerName}</strong>
          </span>
          <span style={sentToFinanceSeparatorStyle}>•</span>
          <span style={sentToFinanceTextStyle}>
            Sent On: <strong>{this.formatTimestamp(timestamps.sentToFinanceDate)}</strong>
          </span>
        </div>
      </div>
    )
  }

  renderApprovalInfo = () => {
    const { checklist } = this.props

    if (!checklist || !this.state.showApprovalInfo) return null

    const l2Approval = checklist.l2Approval && checklist.l2Approval[0]
    const l1Approval = checklist.l1Approval && checklist.l1Approval[0]

    const hasL2Approvals = l2Approval && l2Approval.approvals && l2Approval.approvals.length > 0
    const hasL1Approval = l1Approval && l1Approval.approval

    // Get rework events from approval history
    const reworkEvents = checklist.approvalHistory ? checklist.approvalHistory.filter(
      event => event.eventType === 'L2_REWORK' || event.eventType === 'L1_REWORK'
    ) : []

    if (!hasL2Approvals && !hasL1Approval && reworkEvents.length === 0) {
      return (
        <div className='g_m_top_200' style={approvalInfoContainerStyle}>
          <h4 style={{ margin: '0', fontSize: '16px', color: '#6c757d', textAlign: 'center' }}>
            No approval or rework information available yet
          </h4>
        </div>
      )
    }

    return (
      <div className='g_m_top_200' style={approvalInfoContainerStyle}>
        <h4 style={{ margin: '0 0 15px 0', fontSize: '16px', color: '#333' }}>
          Approval & Rework Information
        </h4>

        {/* L2 Approvals */}
        {hasL2Approvals && (
          <div style={approvalSectionStyle}>
            <div style={approvalHeaderStyle}>
              <strong>L2 Approvals</strong>
              <span style={approvalCountBadgeStyle}>
                {l2Approval.approvalCounter} {l2Approval.approvalCounter === 1 ? 'approval' : 'approvals'} received
                {l2Approval.requiredApprovals && ` (${l2Approval.requiredApprovals} required)`}
              </span>
            </div>
            <div style={approvalListStyle}>
              {l2Approval.approvals.map((approval, index) => (
                <div key={index} style={approvalItemStyle}>
                  <div style={approvalItemHeaderStyle}>
                    <span style={approverNameStyle}>
                      {approval.approverName || approval.approverEmail}
                      {approval.purva && <span style={purvaTagStyle}>Purva</span>}
                    </span>
                    <span style={timestampStyle}>
                      {this.formatTimestamp(approval.timestamp)}
                    </span>
                  </div>
                  {approval.remarks && (
                    <div style={remarksStyle}>
                      <em>Remarks: {approval.remarks}</em>
                    </div>
                  )}
                </div>
              ))}
            </div>
            {l2Approval.majorityReached && (
              <div style={majorityReachedStyle}>
                ✓ L2 Majority Reached
              </div>
            )}
          </div>
        )}

        {/* L1 Approval */}
        {hasL1Approval && (
          <div style={approvalSectionStyle}>
            <div style={approvalHeaderStyle}>
              <strong>L1 Final Approval</strong>
            </div>
            <div style={approvalListStyle}>
              <div style={approvalItemStyle}>
                <div style={approvalItemHeaderStyle}>
                  <span style={approverNameStyle}>
                    {l1Approval.approval.approverName || l1Approval.approval.approverEmail}
                  </span>
                  <span style={timestampStyle}>
                    {this.formatTimestamp(l1Approval.approval.timestamp)}
                  </span>
                </div>
                {l1Approval.approval.remarks && (
                  <div style={remarksStyle}>
                    <em>Remarks: {l1Approval.approval.remarks}</em>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Rework History */}
        {reworkEvents.length > 0 && (
          <div style={reworkSectionStyle}>
            <div style={reworkHeaderStyle}>
              <strong>Rework History</strong>
              <span style={reworkCountBadgeStyle}>
                {reworkEvents.length} {reworkEvents.length === 1 ? 'rework' : 'reworks'}
              </span>
            </div>
            <div style={approvalListStyle}>
              {reworkEvents.map((rework, index) => (
                <div key={index} style={reworkItemStyle}>
                  <div style={approvalItemHeaderStyle}>
                    <span style={reworkerNameStyle}>
                      <span style={reworkLevelTagStyle}>
                        {rework.eventType === 'L2_REWORK' ? 'L2' : 'L1'}
                      </span>
                      {rework.performedByName || rework.performedBy}
                    </span>
                    <span style={timestampStyle}>
                      {this.formatTimestamp(rework.timestamp)}
                    </span>
                  </div>
                  {rework.remarks && (
                    <div style={reworkRemarksStyle}>
                      <em>Reason: {rework.remarks}</em>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }

  render() {
    const {
      context,
      loan,
      checklist,
      checklistExists,
      onGenerateClick,
      onRefreshClick,
      generating,
      loading,
      showErrorModal,
      errorList,
      onCloseErrorModal
    } = this.props

    if (loading) {
      return (
        <div className='c_disb_checklist_view'>
          <div className='g_flex_center g_m_top_200'>
            <div className='g_spinner' />
          </div>
        </div>
      )
    }

    const topActionsRight = (
      <span className='g_flex_h g_flex_left' style={{ alignItems: 'center' }}>
        {checklistExists && (
          <>
            <BadgeUI label={`Status: ${checklist.status}`} />
            <span className='g_m_left_100'>
              Compliance: {checklist.compliancePercentage ? checklist.compliancePercentage.toFixed(1) : '0.0'}%
              ({checklist.totalItemsCount - checklist.pendingItemsCount}/{checklist.totalItemsCount})
            </span>
          </>
        )}
      </span>
    )

    // Check if status is 'approved'
    const isApproved = checklist && checklist.status === 'approved'

    // Check if there's any approval info to show
    const l2Approval = checklist && checklist.l2Approval && checklist.l2Approval[0]
    const l1Approval = checklist && checklist.l1Approval && checklist.l1Approval[0]
    const reworkEvents = checklist && checklist.approvalHistory ? checklist.approvalHistory.filter(
      event => event.eventType === 'L2_REWORK' || event.eventType === 'L1_REWORK'
    ) : []

    const hasAnyApprovals = (l2Approval && l2Approval.approvals && l2Approval.approvals.length > 0) ||
      (l1Approval && l1Approval.approval) || reworkEvents.length > 0

    if (!checklistExists) {
      return (
        <>
          <div className='c_disb_checklist_view'>
            <LRTableActionsUI location='top'
              left={
                <span className='g_flex_left g_flex_h'>
                  <span className='g_m_left_100 g_large'><b>Disbursement Checklist</b></span>
                </span>
              }
              right={topActionsRight}
            />

            <div className='g_m_top_200 g_flex_center'>
              <div className='g_flex_v g_flex_center' style={{ padding: '40px' }}>
                <p className='g_m_bottom_200'>No disbursement checklist has been generated yet.</p>
                <ButtonUI
                  label={generating ? 'Generating...' : 'Generate Checklist'}
                  onClick={onGenerateClick}
                  disabled={generating}
                />
              </div>
            </div>
          </div>

          {/* Error Modal */}
          {showErrorModal && errorList && errorList.length > 0 && (
            <ErrorModalUI
              title="Checklist Generation Failed"
              errorList={errorList}
              onCloseClick={onCloseErrorModal}
            />
          )}
        </>
      )
    }

    return (
      <>
        <div className='c_disb_checklist_view'>
          <LRTableActionsUI location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                <span className='g_m_left_100 g_large'><b>Disbursement Checklist</b></span>
              </span>
            }
            right={topActionsRight}
          />

          {/* Action buttons row */}
          <div className='g_m_top_100' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
            <div style={{ display: 'flex', gap: '10px' }}>
              {['generated', 'l2_rework', 'l1_rework'].includes(checklist.status) && (
                <ButtonUI
                  label="Send for L2 Approval"
                  onClick={this.onSendL2ApprovalClick}
                />
              )}
              {checklist.status === 'sent_for_approval' && (
                <ButtonUI
                  label="L2 Approve/Rework"
                  onClick={this.onL2ApproveReworkClick}
                />
              )}
              {checklist.status === 'l1_approval_pending' && (
                <ButtonUI
                  label="L1 Approve/Rework"
                  onClick={this.onL1ApproveReworkClick}
                />
              )}
              {isApproved && (
                <ButtonUI
                  label="Send to Finance"
                  onClick={this.onSendToFinanceClick}
                />
              )}
            </div>

            {/* Toggle button for approval/rework info */}
            {hasAnyApprovals && (
              <button
                onClick={this.toggleApprovalInfo}
                style={toggleButtonStyle}
              >
                {this.state.showApprovalInfo ? '▼' : '▶'} Approval/Rework Information
              </button>
            )}
          </div>

          {/* Sent to Finance Information */}
          {this.renderSentToFinanceInfo()}

          {/* Approval Information Section */}
          {this.renderApprovalInfo()}

          <div className='g_m_top_100' style={{ overflowX: 'auto' }}>
            <table className='g_table' style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={thStyle}>Sr No</th>
                  <th style={thStyle}>Particulars</th>
                  <th style={thStyle}>CP/CS</th>
                  <th style={thStyle}>Compliance Status</th>
                  <th style={thStyle}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(checklist.items) &&
                  checklist.items
                    .filter(item => item !== null)
                    .map((item, index) => (
                      <tr key={index}>
                        <td style={tdStyleCenter}>{item.displayOrder || index + 1}</td>
                        <td style={tdStyle}>
                          {item.fileCode === "cp_other" && Array.isArray(item.uploadedFileNames) && item.uploadedFileNames.length > 0 ? (
                            <>
                              <div>Other (s):</div>
                              <ol style={{ marginTop: "5px", paddingLeft: "20px" }}>
                                {item.uploadedFileNames.map((name, idx) => (
                                  <li key={idx}>{name}</li>
                                ))}
                              </ol>
                            </>
                          ) : (
                            <>
                              {item.fileCode === 'company_kyc' ? (
                                <a href={`/su/accounts/${loan.accountId}/dataCollection`} style={cpLinkStyle} >
                                  {item.title}
                                </a>
                              ) : item.fileCode === 'director_kyc' ? (
                                <a href={`/su/accounts/${loan.accountId}/directors`} style={cpLinkStyle} >
                                  {item.title}
                                </a>
                              ) : item.type === 'cp' && !NON_LINKABLE_CP_CODES.includes(item.fileCode) ? (
                                <a href={`/su/loans/${loan.loanId}/compliance/cp`} style={cpLinkStyle}>
                                  {item.title}
                                </a>
                              ) : item.type === 'agreement' ? (
                                <a href={`/su/loans/${loan.loanId}/esigning`} style={cpLinkStyle}>
                                  {item.title}
                                </a>
                              ) : (
                                item.title
                              )}
                              {item.shortName && (
                                <span className='g_m_left_100 g_small g_muted'>
                                  ({item.shortName})
                                </span>
                              )}
                            </>
                          )}
                        </td>
                        <td style={tdStyleCenter}>
                          {item.type === 'cp' && <BadgeUI label='CP' />}
                          {item.type === 'agreement' && <BadgeUI label='Agreement' />}
                          {item.type === 'static' && <BadgeUI label='Static' />}
                          {!item.type && '-'}
                        </td>
                        <td style={tdStyleCenter}>
                          {item.complianceStatus === 'complied' && <BadgeUI label='Complied' className='g_badge_success' />}
                          {item.complianceStatus === 'pending' && <BadgeUI label='Pending' className='g_badge_warning' />}
                          {item.complianceStatus === 'moved_to_cs' && <BadgeUI label='Moved To CS' className='g_badge_warning' />}
                          {item.uploadStatus === 'uploaded' && item.uploadedDate && (
                            <div className='g_small g_muted g_m_top_50'>
                              {new Date(item.uploadedDate).toLocaleDateString()}
                            </div>
                          )}
                        </td>
                        <td style={tdStyle}>
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                            <div style={{ flex: 1 }}>
                              {item.remarks && (
                                <div className='g_small g_muted'>{item.remarks}</div>
                              )}
                              {!item.remarks && (
                                <div className='g_small g_muted' style={{ fontStyle: 'italic', color: '#999' }}>
                                  No remarks
                                </div>
                              )}
                            </div>
                            {item.fileCode && (
                              <button
                                onClick={() => this.onAddRemarkClick(item)}
                                style={editIconButtonStyle}
                                title="Add/Edit Remark"
                              >
                                ✏️
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>

          {checklist.generatedBy && (
            <div className='g_m_top_200 g_small g_muted'>
              Generated by {checklist.generatedBy} on {new Date(checklist.generatedDate).toLocaleString()}
            </div>
          )}
        </div>

        {this.state.showSendModal && (
          <SendToL2ApprovalModalSF
            context={context}
            loan={loan}
            onCancelClick={this.onCloseSendModal}
            onSuccess={this.onModalSuccess}
          />
        )}

        {this.state.showL2ApproveReworkModal && (
          <ApproveReworkModalSF
            context={context}
            loan={loan}
            onCancelClick={this.onCloseL2ApproveReworkModal}
            onSuccess={this.onModalSuccess}
          />
        )}

        {this.state.showL1ApproveReworkModal && (
          <L1ApproveReworkModalSF
            context={context}
            loan={loan}
            onCancelClick={this.onCloseL1ApproveReworkModal}
            onSuccess={this.onModalSuccess}
          />
        )}

        {this.state.showSendToFinanceModal && (
          <SendToFinanceModalSF
            context={context}
            loan={loan}
            onCancelClick={this.onCloseSendToFinanceModal}
            onSuccess={this.onModalSuccess}
          />
        )}

        {this.state.showAddRemarkModal && this.state.selectedItem && (
          <AddRemarkModalSF
            context={context}
            loan={loan}
            item={this.state.selectedItem}
            onCancelClick={this.onCloseAddRemarkModal}
            onSuccess={this.onModalSuccess}
          />
        )}

        {/* Rework Warning Modal */}
        {this.state.showReworkWarningModal && (
          <ErrorModalUI
            title="Already Sent to Rework"
            errorList={[this.state.reworkWarningMessage]}
            type="warning"
            onCloseClick={this.onCloseReworkWarningModal}
          />
        )}
      </>
    )
  }
}

// Table styles
const thStyle = { width: 'auto', padding: '12px', border: '1px solid #ddd', backgroundColor: '#f5f5f5' }
const tdStyle = { padding: '12px', border: '1px solid #ddd', whiteSpace: 'pre-wrap' }
const tdStyleCenter = { padding: '12px', border: '1px solid #ddd', textAlign: 'center' }
const cpLinkStyle = { color: '#007bff', textDecoration: 'none', cursor: 'pointer' }

// Edit icon button style
const editIconButtonStyle = {
  padding: '4px 8px',
  fontSize: '16px',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: '1px solid #dee2e6',
  borderRadius: '4px',
  transition: 'all 0.2s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const toggleButtonStyle = {
  padding: '6px 12px',
  fontSize: '13px',
  fontWeight: '500',
  color: '#007bff',
  backgroundColor: '#fff',
  border: '1px solid #007bff',
  borderRadius: '3px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '4px'
}

// Sent to Finance styles - Single line, long box
const sentToFinanceContainerStyle = {
  backgroundColor: '#d1ecf1',
  border: '2px solid #28a745',
  borderRadius: '6px',
  padding: '10px 16px',
  marginBottom: '15px',
  width: '100%',
  boxSizing: 'border-box'
}

const sentToFinanceContentStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flexWrap: 'nowrap'
}

const sentToFinanceIconStyle = {
  fontSize: '18px',
  color: '#28a745',
  fontWeight: 'bold',
  flexShrink: 0
}

const sentToFinanceHeaderTextStyle = {
  fontSize: '14px',
  color: '#155724',
  flexShrink: 0
}

const sentToFinanceSeparatorStyle = {
  fontSize: '14px',
  color: '#0c5460',
  fontWeight: 'bold',
  flexShrink: 0
}

const sentToFinanceTextStyle = {
  fontSize: '13px',
  color: '#0c5460',
  flexShrink: 0
}

// Approval info styles
const approvalInfoContainerStyle = {
  backgroundColor: '#f8f9fa',
  border: '1px solid #dee2e6',
  borderRadius: '8px',
  padding: '20px',
  marginBottom: '20px'
}

const approvalSectionStyle = {
  backgroundColor: '#fff',
  border: '1px solid #e0e0e0',
  borderRadius: '6px',
  padding: '15px',
  marginBottom: '15px'
}

const approvalHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '12px',
  paddingBottom: '10px',
  borderBottom: '2px solid #e9ecef',
  fontSize: '14px',
  color: '#495057'
}

const approvalCountBadgeStyle = {
  backgroundColor: '#007bff',
  color: '#fff',
  padding: '4px 10px',
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: '500'
}

const approvalListStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px'
}

const approvalItemStyle = {
  backgroundColor: '#f8f9fa',
  border: '1px solid #dee2e6',
  borderRadius: '4px',
  padding: '12px',
  transition: 'all 0.2s'
}

const approvalItemHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px'
}

const approverNameStyle = {
  fontWeight: '600',
  color: '#212529',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}

const purvaTagStyle = {
  backgroundColor: '#ffc107',
  color: '#000',
  padding: '2px 8px',
  borderRadius: '10px',
  fontSize: '11px',
  fontWeight: '600',
  marginLeft: '6px'
}

const timestampStyle = {
  color: '#6c757d',
  fontSize: '13px',
  fontStyle: 'italic'
}

const remarksStyle = {
  marginTop: '8px',
  color: '#6c757d',
  fontSize: '13px',
  paddingLeft: '10px',
  borderLeft: '3px solid #dee2e6'
}

const majorityReachedStyle = {
  marginTop: '12px',
  padding: '8px 12px',
  backgroundColor: '#d4edda',
  color: '#155724',
  borderRadius: '4px',
  fontSize: '13px',
  fontWeight: '600',
  textAlign: 'center'
}

// Rework section styles
const reworkSectionStyle = {
  backgroundColor: '#fff',
  border: '1px solid #ffc107',
  borderRadius: '6px',
  padding: '15px',
  marginBottom: '15px'
}

const reworkHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '12px',
  paddingBottom: '10px',
  borderBottom: '2px solid #ffc107',
  fontSize: '14px',
  color: '#856404'
}

const reworkCountBadgeStyle = {
  backgroundColor: '#ffc107',
  color: '#000',
  padding: '4px 10px',
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: '600'
}

const reworkItemStyle = {
  backgroundColor: '#fff3cd',
  border: '1px solid #ffc107',
  borderRadius: '4px',
  padding: '12px',
  transition: 'all 0.2s'
}

const reworkerNameStyle = {
  fontWeight: '600',
  color: '#856404',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}

const reworkLevelTagStyle = {
  backgroundColor: '#856404',
  color: '#fff',
  padding: '2px 8px',
  borderRadius: '10px',
  fontSize: '11px',
  fontWeight: '600'
}

const reworkRemarksStyle = {
  marginTop: '8px',
  color: '#856404',
  fontSize: '13px',
  paddingLeft: '10px',
  borderLeft: '3px solid #ffc107'
}

export default DisbursementChecklistViewUI